import React, { useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import { useModal } from './ModalContext';
import '../styles/Modal.scss';
import { Snackbar, Alert } from '@mui/material';
const intitalData = {
    name: '',
    company: '',
    phone: '',
    email: '',
    message: ''
}
const Modal: React.FC = () => {
    const CloseIcon = `${process.env.REACT_APP_S3_URL}close.svg`;
    const ArrowIcon = `${process.env.REACT_APP_S3_URL}RIghtArrowBgWhite.svg`;
    const { isOpen, closeModal } = useModal();
    const [formData, setFormData] = useState(intitalData);
    const [loading, setLoading] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState<'success' | 'error'>('success');
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const showToast = (message: string, type: 'success' | 'error') => {
        setToastMessage(message);
        setToastType(type);
        setToastOpen(true);
    };

    const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') return;
        setToastOpen(false);
    };

    const onChange = (token: string | null) => {
        // reCAPTCHA token received
    };

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10,}$/;

        if (!formData.name.trim()) {
            showToast("Name is required.", 'error');
            return false;
        }
        else if (!formData.company.trim()) {
            showToast("Company is required.", 'error');
            return false;
        }
        else if (!phoneRegex.test(formData.phone)) {
            showToast("Phone number must be 10 digits.", 'error');
            return false;
        }
        else if (!emailRegex.test(formData.email)) {
            showToast("Invalid email format.", 'error');
            return false;
        }
        else if (!formData.message.trim()) {
            showToast("Message is required.", 'error');
            return false;
        }
        return true;
    }
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        if (!recaptchaRef.current) {
            showToast("reCAPTCHA component error. Please refresh the page.", 'error');
            return;
        }

        const recaptchaToken = recaptchaRef.current.getValue();
        
        if (!recaptchaToken) {
            showToast("Please check the reCAPTCHA checkbox and wait for verification to complete.", 'error');
            return;
        }
    
        try {
            setLoading(true);
            const payload = {
                ...formData,
                recaptchaToken
            };
            const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/v1/contactus', payload);
            
            showToast("Email sent successfully!", 'success');
            setFormData(intitalData);
            recaptchaRef.current?.reset();
            
            setTimeout(() => {
                setLoading(false);
                closeModal();
            }, 2000);
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : "Failed to send message. Please try again later.";
            showToast(errorMsg, 'error');
            recaptchaRef.current?.reset();
            setLoading(false);
        }
    };
    

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'start'
                }}>
                    <div>
                        <h1 style={{ margin:0, marginTop:32}}>
                            <span className="partner">Partner</span>
                            <span className="with-us"> With Us</span>
                        </h1>
                        <p>Elevate your business with cutting edge payments infrastructure</p>
                    </div>
                    <button onClick={closeModal} className="close-button">
                        <img src={CloseIcon} alt="Close" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input type="text" id="name" placeholder="Name" required value={formData.name} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <input type="text" id="company" placeholder="Company" required value={formData.company} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <input type="tel" id="phone" placeholder="Phone no." required value={formData.phone} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <input type="email" id="email" placeholder="Email ID" required value={formData.email} onChange={handleChange} />
                    </div>
                    <div className="form-group text-area">
                        <textarea id="message" placeholder="Message" required value={formData.message} onChange={handleChange}></textarea>
                    </div>
                    <div className="checkbox-container">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
                            onChange={onChange}
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <button type="submit" className="send-button" disabled={loading}>
                            <span>{loading ? "Sending..." : "Send"}</span>
                            <img src={ArrowIcon} alt="arrow" width="30" />
                        </button>
                    </div>
                    
                    {/* Toast Notification */}
                    <Snackbar 
                        open={toastOpen} 
                        autoHideDuration={4000} 
                        onClose={handleToastClose}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <Alert 
                            onClose={handleToastClose} 
                            severity={toastType} 
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {toastMessage}
                        </Alert>
                    </Snackbar>
                </form>
            </div>
        </div>
    );
};

export default Modal;
